import { render, staticRenderFns } from "./TasksRightCornerImagesBox.vue?vue&type=template&id=20cfd58d&scoped=true&"
import script from "./TasksRightCornerImagesBox.vue?vue&type=script&lang=js&"
export * from "./TasksRightCornerImagesBox.vue?vue&type=script&lang=js&"
import style0 from "./TasksRightCornerImagesBox.vue?vue&type=style&index=0&id=20cfd58d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfd58d",
  null
  
)

export default component.exports